<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <b-card>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Activité du véhicule</h5>
          <b-button size="sm" variant="outline-primary" @click="loadFeed">
            <feather-icon icon="RefreshCwIcon" />
            Actualiser
          </b-button>
        </div>

        <div v-if="!loading && !feed.length" class="text-center text-muted py-3">
          <feather-icon icon="ClockIcon" size="32" class="mb-1" />
          <div>Aucune activité enregistrée pour ce véhicule.</div>
        </div>

        <app-timeline v-else>
          <app-timeline-item
            v-for="(item, idx) in feed"
            :key="item.source + '-' + item.id + '-' + idx"
            :variant="variantFor(item)"
            :icon="iconFor(item)"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6 class="mb-0">
                <b-badge :variant="variantFor(item)" class="mr-1">
                  {{ actionLabel(item.action) }}
                </b-badge>
                <span>{{ titleFor(item) }}</span>
              </h6>
              <small class="text-nowrap text-muted">
                {{ formatDate(item.created_at) }}
              </small>
            </div>

            <p v-if="item.user" class="mb-0 text-muted small">
              <feather-icon icon="UserIcon" size="12" />
              {{ userLabel(item.user) }}
            </p>

            <ul
              v-if="item.source === 'user_action_log' && item.details && item.details.changes"
              class="mt-1 mb-0 pl-3 small"
            >
              <li v-for="(diff, field) in item.details.changes" :key="field">
                <strong>{{ field }}</strong> :
                <span class="text-danger">{{ formatValue(diff.old) }}</span>
                →
                <span class="text-success">{{ formatValue(diff.new) }}</span>
              </li>
            </ul>
          </app-timeline-item>
        </app-timeline>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { BCard, BButton, BBadge, BOverlay } from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import axios from '@/libs/axios'

export default {
  name: 'VehiculeActivites',
  components: {
    BCard,
    BButton,
    BBadge,
    BOverlay,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    vehicule: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      feed: [],
    }
  },
  watch: {
    'vehicule.id': {
      immediate: true,
      handler(id) {
        if (id) {
          this.loadFeed()
        }
      },
    },
  },
  methods: {
    async loadFeed() {
      if (!this.vehicule || !this.vehicule.id) return
      this.loading = true
      try {
        const { data } = await axios.get(`/api/logs/vehicule/${this.vehicule.id}`)
        this.feed = data.data || []
      } catch (e) {
        this.feed = []
      } finally {
        this.loading = false
      }
    },
    variantFor(item) {
      if (item.source === 'vehicule_historique') return 'success'
      switch (item.action) {
        case 'create': return 'primary'
        case 'update': return 'success'
        case 'delete': return 'danger'
        default: return 'secondary'
      }
    },
    iconFor(item) {
      if (item.source === 'vehicule_historique') return 'EditIcon'
      switch (item.action) {
        case 'create': return 'PlusIcon'
        case 'update': return 'EditIcon'
        case 'delete': return 'Trash2Icon'
        default: return 'CircleIcon'
      }
    },
    actionLabel(action) {
      switch (action) {
        case 'create': return 'Création'
        case 'update': return 'Modification'
        case 'delete': return 'Suppression'
        default: return action
      }
    },
    titleFor(item) {
      if (item.log) return item.log
      switch (item.action) {
        case 'create': return 'Création du véhicule'
        case 'delete': return 'Suppression du véhicule'
        case 'update': return 'Mise à jour du véhicule'
        default: return 'Action sur le véhicule'
      }
    },
    userLabel(user) {
      if (!user) return '-'
      const fullname = [user.prenom, user.nom].filter(Boolean).join(' ')
      return fullname || user.email || `Utilisateur #${user.id}`
    },
    formatDate(value) {
      if (!value) return '-'
      const d = new Date(value)
      return d.toLocaleDateString('fr') + ' ' + d.toLocaleTimeString('fr', { hour: '2-digit', minute: '2-digit' })
    },
    formatValue(v) {
      if (v === null || v === undefined || v === '') return '∅'
      if (typeof v === 'boolean') return v ? 'Oui' : 'Non'
      return String(v)
    },
  },
}
</script>
